import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ApiService } from 'src/app/core';
import { HandleError, HttpErrorHandler } from 'src/app/http-error-handler.service';
import { catchError, map } from 'rxjs/operators';
import { SubjectCustomer } from 'src/app/modelo/SubjectCustomer';
import { UsuarioModel } from 'src/app/modelo/usuario.model';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class RegistroService {

    private apiServer = '';
    private handleError: HandleError;

    private uuidUser: string;

    getUserUUID() {
        return this.uuidUser;
    }

    setUserUUID(uuidUser: string) {
        this.uuidUser = uuidUser;
    }

    constructor(
        private apiService: ApiService,
        private httpErrorHandler: HttpErrorHandler,
    ) {
        this.apiServer = environment.settings.apiServer;
        this.handleError = httpErrorHandler.createHandleError('RegistroService');
    }

    /*************************************************************************************
    **REQUEST HTTP
    **************************************************************************************/
    async getUserPorCodeData(code: string): Promise<any> {
        return this.getUserPorCode(code).toPromise();
    }
    getUserPorCode(code: string) {
        return this.apiService.get(this.apiServer + '/registro/users/code/' + code + '')
            .pipe(
                catchError(this.handleError('RegistroService.getUserPorCode'))
            )
    }

    async getEmailPorCodeData(code: string): Promise<any> {
        return this.getEmailPorCode(code).toPromise();
    }
    getEmailPorCode(code: string) {
        return this.apiService.get(this.apiServer + '/registro/users/email/' + code + '')
            .pipe(
                catchError(this.handleError('RegistroService.getEmailByCode'))
            )
    }

    async getPlanesData(): Promise<any> {
        return this.getPlanes().toPromise();
    }
    getPlanes() {
        return this.apiService.get(this.apiServer + '/registro/planes')
            .pipe(
                catchError(this.handleError('RegistroService.getPlanes'))
            )
    }

    async getPlanesPorTipoPlanData(tipoPlan: string): Promise<any> {
        return this.getPlanesPorTipoPlan(tipoPlan).toPromise();
    }
    getPlanesPorTipoPlan(tipoPlan: string) {
        return this.apiService.get(this.apiServer + '/registro/planes/tipo/' + tipoPlan)
            .pipe(
                catchError(this.handleError('RegistroService.getPlanesPorTipoPlan'))
            )
    }

    enviarUser(user: UsuarioModel) {
        if (user.code && user.email && user.password) {
            if (user.uuid) {
                return this.apiService.put(this.apiServer + '/registro/users', user)
                    .pipe(map(data => data['user']));
            } else {
                return this.apiService.post(this.apiServer + '/registro/users', user)
                    .pipe(map(data => data['user']));
            }
        }
    }
    
    /**
    * Comprar plan o planes y actualizar el plan vigente.
    */
    comprarPlan(user: UsuarioModel) {
        //if (user.code && user.email && user.password) {
        if (user.uuid) {
            return this.apiService.put(this.apiServer + '/registro/users/actualizar/plan', user)
                .pipe(map(data => data['user']));
        } else {
            //TODO para regalar un plan de facturación
            return this.apiService.post(this.apiServer + '/registro/users', user)
                .pipe(map(data => data['user']));
        }
        //}
    }


    enviarPeticionResetContrasenia(usuarioModel: UsuarioModel): Observable<UsuarioModel> {
        if (usuarioModel.code && usuarioModel.email) {
            return this.apiService.put(this.apiServer + '/registro/users/password/request', usuarioModel)
                .pipe(map(data => data['user']));
        }
    }

    actualizarResetUsuarioContrasenia(usuarioModel: UsuarioModel): Observable<UsuarioModel> {
        if (usuarioModel.uuid) {
            return this.apiService.put(this.apiServer + '/registro/users/password/reset', usuarioModel)
                .pipe(map(data => data['user']));
        }
    }
}
